<template>
    <div class="main">
        <a-card style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Vaccine Template</h3>
                <!-- <div>
                <a-form-model
                    ref="loginForm"
                    :model="form"
                    :rules="rules"
                >
                    <a-form-model-item>
                        <a-input v-model="searchText" placeholder="search for anything">
                            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                </a-form-model>

            </div> -->
                <!-- <div>
                <a-input-search placeholder="Search by product name" style="width: 219px" @search="onSearch" />
            </div> -->
                <div style="display:flex; justify-content: space-around;">
                    <!-- <a-button @click="showLowStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" >
                 Replenish Low Stock
                 <span class="px-2"> <a-badge :count="balLessThan20.length" show-zero :number-style="{ backgroundColor: '#52c41a' }"/></span>
                </a-button> -->


                    <!-- <a-button @click="showOutOfStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" > -->

                    <a-button @click="showVaccineModal"
                        style="border-raduis:6px; background: #fff;color:#0F3659; margin-right:10px;">
                        <a-icon type="plus" /> Add New Template
                    </a-button>
                    <!-- 
                <a-button :loading="exportLoading" @click="exportExcell" style="border-raduis:6px; background: #fff;color:#0F3659" icon="upload" >
                 Export
                </a-button>  -->
                </div>

            </div>
            <div>
                <a-table :columns="columns" :data-source="tableData" :pagination="pagination" :loading='tableLoading'
                    :scroll="{ x: 1500, y: 600 }" @change="handleTableChange" class="tableStyle">

                    <SettingIcon slot="filterIcon" slot-scope="" />


                    <span slot="actions" slot-scope="data">
                        <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
                        <!-- <a @click="showMoreDetails(data)" style="color:#98c14b;"><a-icon style="font-size:25px;" type="ellipsis" /> </a> -->
                        <a-dropdown>
                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-icon style="font-size:25px;" type="ellipsis" />
                            </a>
                            <a-menu slot="overlay">

                                <!-- <a-menu-item>
                                    <a @click="showEditDetails(data)">Edit Product?</a>
                                </a-menu-item>
                                <a-menu-item>
                                    <a @click="showUploadImage(data)">Upload Product Image?</a>
                                </a-menu-item> -->
                                <a-menu-item>
                                    <a @click="showMoreDetailsModal(data)">More Details?</a>
                                </a-menu-item>
                                <!-- <a-menu-item>
                                    <a @click="showPriceModal(data)">Set Price?</a>
                                </a-menu-item> -->
                                <!-- <a-menu-item>
                                    <a href="javascript:;">View Product Details</a>
                                </a-menu-item>
                                <a-menu-item>
                                    <a href="javascript:;">View Inventory Details</a>
                                </a-menu-item> -->
                            </a-menu>
                        </a-dropdown>
                    </span>

                    <template slot="thumb" slot-scope="">
                        <img src='../../assets/img/biothrax_bottom_260_x_300_removebg_preview.png' />
                    </template>

                    <template slot="templateStatusLabel" slot-scope="data">
                        <status-component :status="data"></status-component>
                    </template>
                </a-table>

            </div>
        </a-card>


        <a-modal class="modalStyle" :visible="addVaccineTempVisible" :footer="null" width="800px"
            @cancel="closeVaccineModal">
            <p style="text-align:center;font-weight: bolder;padding-top: 10px;">Add Vaccine Template</p>
            <div style="display:flex;justify-content: center;">
                <a-form-model ref="addVaccineTemplateRef" :model="addVaccineTempModel" :rules="rules">
                    <a-row>
                        <a-col :span="8" :offset="0">
                            <a-form-model-item label="Template Name" ref="name" prop="name">
                                <a-input class="" v-model="addVaccineTempModel.name" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8" :offset="5">
                            <a-form-model-item label="Template Type" ref="type" prop="type">
                                <a-select v-model="addVaccineTempModel.type" placeholder="please select your type">
                                    <a-select-option v-bind:value="0"> Standard </a-select-option>
                                    <a-select-option v-bind:value="1"> Custom </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row style="margin-top:53px;">
                        <a-col :span="8" :offset="0">
                            <a-form-model-item label="Target Species" ref="species" prop="species">
                                <a-select v-model="addVaccineTempModel.species"
                                    placeholder="please select your species">
                                    <a-select-option v-bind:value="0"> Chicken </a-select-option>
                                    <a-select-option v-bind:value="1"> GuineaFowl </a-select-option>
                                    <a-select-option v-bind:value="2"> Turkey </a-select-option>
                                    <a-select-option v-bind:value="3"> Duck </a-select-option>
                                    <a-select-option v-bind:value="4"> Quail </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8" :offset="5">
                            <a-form-model-item label="Status" ref="status" prop="status">
                                <a-select v-model="addVaccineTempModel.status" placeholder="please select status">
                                    <a-select-option v-bind:value="1"> Active </a-select-option>
                                    <a-select-option v-bind:value="0"> Inactive </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row style="margin-top:53px;">
                        <a-col :span="8" :offset="0">
                            <a-form-model-item label="Start Age(days)" ref="startAge" prop="startAge">
                                <a-input class="" v-model="addVaccineTempModel.startAge" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8" :offset="5">
                            <a-form-model-item label="End Age(days)" ref="endAge" prop="endAge">
                                <a-input class="" v-model="addVaccineTempModel.endAge" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>

            </div>

            <div style="display:flex;justify-content: center;padding-bottom: 10px;padding-top:40px">
                <a-spin class="spinner" :spinning="loading" />
            </div>
            <div style="display: flex;justify-content: center;padding-top:30px">
                <a-button @click="handleAddVaccineTemplate" style="background: #418a49;color:#fff;border-radius:5px;">
                    Add Vaccine Template
                </a-button>
            </div>
        </a-modal>

    </div>
</template>



<script>
import { mapActions, mapGetters } from 'vuex';
import XLSX from "xlsx";
import moment from 'moment';
import StatusComponent from "@/components/shared-components/StatusComponent.vue";
// import SettingSvg from '../../assets/img/settings.svg';
// import _ from 'lodash';
// import reqwest from 'reqwest';
import SettingIcon from '../common/components/SettingIcon.vue'


const columns = [
    //   {
    //     title: 'Thumb',
    //     // width: 80,
    //     key: 'thumb',
    //     scopedSlots: { customRender: 'thumb' },
    //   },
    {
        title: 'Template ID',
        key: 'id',
        dataIndex: 'id',
        width: 150,
    },
    {
        title: 'Status',
        dataIndex: 'templateStatusLabel',
        key: 'templateStatusLabel',
        width: 150,
        scopedSlots: { customRender: 'templateStatusLabel' },
        // onFilter: (value, record) =>
        // record.productName
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
    },
    {
        title: 'Template Type',
        dataIndex: 'templateTypeLabel',
        key: 'templateTypeLabel',
        width: 150,

        // onFilter: (value, record) =>
        // record.category
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
        // width: 200,
    },
    {
        title: 'Template Name',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        // onFilter: (value, record) =>
        // record.supplier
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
        // width: 200,
    },
    {
        title: 'Target Species',
        dataIndex: 'poultrySpeciesLabel',
        key: 'poultrySpeciesLabel',
        width: 150,

        // onFilter: (value, record) =>
        // record.supplier
        //     .toString()
        //     .toLowerCase()
        //     .includes(value.toLowerCase()),
        // width: 200,
    },

    {
        title: 'Start Age',
        width: 150,
        dataIndex: 'startAge',
    },
    {
        title: 'End Age',
        width: 150,
        dataIndex: 'endAge',
    },
    {
        title: 'Last Updated',
        width: 200,
        dataIndex: 'createdAt',
    },
    {
        title: 'Actions',
        key: 'actions',
        width: 100,
        align: 'center',
        scopedSlots: { customRender: 'actions' },
    },
];


export default {
    name: 'VaccineTemplates',
    components: {
        SettingIcon,
        StatusComponent
    },
    data() {
        return {
            data: [],
            columns,
            product: {},
            pagination: {
                pageSize: 20,
                current: 1
            },
            addVaccineTempVisible: false,
            params: {
                page: 1,
                perPage: 20,
                searchBy: {},
                sortBy: {}
            },
            tableData: [],
            tableLoading: false,
            loading: false,
            exportLoading: false,
            addVaccineTempModel: {
                name: '',
                type: '',
                species: '',
                startAge: '',
                endAge: '',
                status: ''
            },
            rules: {
                name: [
                    { required: true, message: 'Please enter name', trigger: 'change' },

                ],
                type: [
                    { required: true, message: 'Please select your type', trigger: 'change' },

                ],
                species: [
                    { required: true, message: 'Please select your species', trigger: 'change' },
                ],
                startAge: [
                    { required: true, message: 'Please enter start age', trigger: 'change' },
                ],
                endAge: [
                    { required: true, message: 'Please enter end age', trigger: 'change' },
                ],
                status: [
                    { required: true, message: 'Please select status', trigger: 'change' },
                ],
            }
        };
    },
    computed: {
        ...mapGetters(['getPagination']),
        sortedData() {
            // console.log("sorted | ", _.sortBy(this.data, 'createdAt'))
            // return _.orderBy(this.data, 'createdAt','desc');
            return this.data;
        }
    },
    methods: {
        ...mapActions(['finalAgentInventory', 'addVaccineTemplate', 'setCatalogInfo', 'finalAgentInventorySearchSort', 'setProductPrice', 'uploadProductImage', 'finalCategoryManufacturerSupplierList', 'setProductStatus', 'setPaginationInfo', 'setPreviewInfo']),
        handleSubmit() {
            // console.log(this.formInline);
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        handleTableChange(pagination) {
            this.tableLoading = true
            // console.log("pagination before change | ", this.pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            // console.log("pagination after change | ", this.pagination);
            this.setPaginationInfo(this.pagination)
            this.tableLoading = false
        },

        showVaccineModal() {
            this.addVaccineTempVisible = true;
        },
        closeVaccineModal() {
            this.addVaccineTempVisible = false;
        },
        showAddProductPage() {
            this.$router.push('/new-product').catch(() => { });
        },
        showAddStockPage() {
            this.$router.push('/add-stock').catch(() => { });
        },
        showMoreDetailsModal(data) {
            this.$router.push({
                name: 'vaccine-template-details',
                params: { id: data?.id }
            }).catch(() => { });
        },
        showPriceModal(data) {
            this.setPrice.sellingPrice = data.action.sellingPrice
            this.setPrice.purchasePrice = data.action.purchasePrice
            this.isPriceVisible = true
            this.product = data
        },

        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        exportExcell() {
            this.exportLoading = true
            const dataToExport = [
                [
                    "Product ID",
                    "Product Name",
                    "Category",
                    "Supplier",
                    "Manufacturer",
                    "Quantity",
                    "Commission",
                    "Cost Price(Ksh)",
                    "Selling Price",
                    "Profit Margin"
                ],
            ];

            this.data.forEach((v) => {
                dataToExport.push([
                    v.id,
                    v.productName,
                    v.category,
                    v.supplier,
                    v.manufacturer,
                    v.quantity,
                    v.commission,
                    v.costPrice,
                    v.price,
                    v.profitMargin
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Product-Catalog-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.exportLoading = false;
            this.showSuccessAlert("Data Successfully Exported")

        },

        showConfirm(data) {
            this.$confirm({
                title: `Delete Product?`,
                content: `Do you want to delete this product, ${data.title} ?`,
                onOk() {
                    return new Promise((resolve, reject) => {
                        setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                    }).catch(() => console.log('Oops errors!'));
                },
                onCancel() { },
            });
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file) {
            // console.log("file type | ", file.type)
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

            if (!isJpgOrPng) {
                this.fileList = [];
                this.showErrorAlert("You can only upload PNG or JPEG file!")
                // console.log("fileList not png | ", this.fileList)
                return false;
            } else {
                // console.log("fileList png | ", this.fileList)
                this.fileList = [...this.fileList, file];
                return false;
            }
        },
        handleUpload() {
            const { fileList } = this;
            const formData = new FormData();
            fileList.forEach(file => {
                formData.append('Image', file);
            });
            this.uploading = true;
            let request_data = {
                ProductId: this.productId,
                formData: formData
            }

            this.uploadProductImage(request_data).then(response => {
                // console.log("response image | ", response)
                this.uploadImageVisible = false
                this.fileList = [];
                this.uploading = false;
                if (response.status === 200) {
                    this.getProducts();
                    this.showSuccessAlert("Product Image Uploaded Successfully")
                } else {
                    this.showErrorAlert(response.data.messages)
                }
            },
                error => {
                    this.uploading = false;
                    this.showErrorAlert(JSON.stringify(error))
                })
        },
        randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        },
        showOutOfStockPage() {
            let distributionData = this.inventoryWithOutBal.map(product => ({
                key: this.randomString(10),
                id: product.key,
                name: product.productName ? product.productName : "N/A",
                category: product.category ? product.category : "N/A",
                quantity: product.quantity ? product.quantity.toString() : '0',
                unitPrice: product.costPrice ? product.costPrice.toString() : "0",
                lineTotal: parseInt(product.quantity) * parseInt(product.costPrice),
                extra_data: product.action

            }))

            let previewData = {
                discount: '',
                deliveryDate: "",
                supplierName: "",
                supplierId: "",
                distributionCentreName: '',
                distributionCentreId: '',
                supplierAddress: '',
                supplierCity: '',
                supplierCountry: '',
                destionation: '',
                shipAddress: '',
                shipCity: '',
                shipCountry: '',
                shippingMethod: '',
                shippinTerm: '',
                originalData: distributionData,
                tableData: distributionData
            }
            // console.log("previewData | ", previewData)
            this.setPreviewInfo(JSON.stringify(previewData));
            this.$router.push('/quick-action-receipt').catch(() => { });
        },
        showLowStockPage() {
            let distributionData = this.balLessThan20.map(product => ({
                key: this.randomString(10),
                id: product.key,
                name: product.productName ? product.productName : "N/A",
                category: product.category ? product.category : "N/A",
                quantity: product.quantity ? product.quantity.toString() : '0',
                unitPrice: product.costPrice ? product.costPrice.toString() : "0",
                lineTotal: parseInt(product.quantity) * parseInt(product.costPrice),
                extra_data: product.action
            }))

            let previewData = {
                discount: '',
                deliveryDate: "",
                supplierName: "",
                supplierId: "",
                distributionCentreName: '',
                distributionCentreId: '',
                supplierAddress: '',
                supplierCity: '',
                supplierCountry: '',
                destionation: '',
                shipAddress: '',
                shipCity: '',
                shipCountry: '',
                shippingMethod: '',
                shippinTerm: '',
                originalData: distributionData,
                tableData: distributionData
            }
            //   console.log("previewData | ", previewData)
            this.setPreviewInfo(JSON.stringify(previewData));
            this.$router.push('/quick-action-receipt').catch(() => { });
        },

        handleAddVaccineTemplate() {
            this.$refs.addVaccineTemplateRef.validate(async valid => {
                if (valid) {
                    this.loading = true;

                    const request = {
                        name: this.addVaccineTempModel.name,
                        type: parseInt(this.addVaccineTempModel.type),
                        species: parseInt(this.addVaccineTempModel.species),
                        startAge: parseInt(this.addVaccineTempModel.startAge),
                        endAge: parseInt(this.addVaccineTempModel.endAge),
                        status: parseInt(this.addVaccineTempModel.status)
                    }

                    const response = await this.$store.dispatch("vaccineTemplate/addVaccineTemplate", request);

                    this.loading = false
                    if (response.status === 200) {
                        this.showSuccessAlert("New Vaccine Template Created Successfully")
                        this.getVaccineTemplates();
                        this.addVaccineTempModel = {
                            name: '',
                            type: '',
                            species: '',
                            startAge: '',
                            endAge: '',
                            status: ''
                        }
                        this.addVaccineTempVisible = false;
                    } else {
                        this.showErrorAlert(response.data.messages)
                    }
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        async getVaccineTemplates() {
            this.tableLoading = true;
            const response = await this.$store.dispatch('vaccineTemplate/getTemplates');
            this.tableLoading = false;
            this.setTableData(response.data)
        },

        setTableData(data) {
            this.tableData = data.data.map(template => {
                return {
                    ...template,
                    key: template.id,
                    createdAt: moment(template.createdAt).format("DD/MM/YYYY HH:mm:ss A")
                };
            });
        }

    },
    created() {
        this.getVaccineTemplates();
    },
}
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.ant-form-item {
    font-size: 14px;
    height: 38px;
    width: 294px;
    border-radius: 5px;
}

.ant-form-item>>>span {
    text-align: center;
}

.ant-btn {
    line-height: 1.499;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;

    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    touch-action: manipulation;
    height: 38px;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.65);
    background-color: #fff;

}

.ant-btn:hover,
.ant-btn:focus {
    color: #418a49;
    background-color: #fff;
    border-color: #418a49;
}

/* .ant-input:focus,
.ant-input:hover {
    border-color: #418a49;
    border-right-width: 1px !important;
    outline: 0;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
} */

.actionIcons {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.actionLinks {
    color: #777777;
}

.rightSideinputText {
    width: 100%;
    height: 50px;
    border-radius: 5px;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
    width: 100%
}


.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

.ant-switch-checked {
    background-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}
</style>
